import { useMutation, useQueryClient } from "@tanstack/react-query";

import { BILLING_QUERY_KEYS } from "Billing/Api/Queries/queryKeys";
import { apiPost, type FetchResponse, getApiUrl } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import {
  getResourcePath,
  Resources,
} from "Infrastructure/Translations/Resources";

interface InitiateDepositRequest {
  amount: number;
  description: string | null;
  idempotencyKey: string;
}

export interface InitiateDepositResult {
  paymentIntentID: string;
  checkoutUrl: string;
}

type InitiateDepositResponse = FetchResponse<InitiateDepositResult, 200>;

export function useInitiateDepositMutation() {
  const queryClient = useQueryClient();

  const mutationFn = processResponse(
    (request: InitiateDepositRequest) =>
      apiPost<InitiateDepositResponse, InitiateDepositRequest>(
        `${getApiUrl()}/api/v1/billing/initiate-deposit`,
        request,
        undefined,
      ) as unknown as Promise<InitiateDepositResponse>,
    { translationPrefix: getResourcePath(Resources.ApiErrors.InitiateDeposit) },
  );

  return useMutation({
    mutationFn,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: BILLING_QUERY_KEYS.all,
      });
    },
  });
}
